module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-28.6d24d7a5.png";